import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Filter} from '../filter';
import {NgClass} from '@angular/common';
import {ServerFilterValue} from '../filter-bar/server-filter-value';
import {AssetStateService} from '../../assets/asset.state.service';
import {Subscription} from 'rxjs';
import {AssetFilter} from '../../assets/asset-filter';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-filter',
  imports: [
    NgClass,
    TranslatePipe
  ],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss'
})
export class FilterComponent implements OnInit , OnDestroy{
  @Input() filter: Filter | undefined;
  @Output() filterChange = new EventEmitter<Filter>();
  assetFilterSubscription: Subscription | undefined;
  assetFilter: AssetFilter | undefined;
  blocked = true;
  blockedSubscription: Subscription | undefined;
  @Input() showSport: boolean = false;
  @Input() showProductType: boolean = false;
  constructor(private assetStateService: AssetStateService) {
  }
  ngOnInit() {
    this.assetFilterSubscription = this.assetStateService.filter$.subscribe(filter => {
      if (filter) {
        this.assetFilter = filter;
        if (this.filter) {
         //     console.log('updating assetFilter', filter);
          this.checkIfStillSelected()
        }
      }
    })
    this.blockedSubscription = this.assetStateService.filterBlocked$.subscribe(blocked => {
      this.blocked = blocked;
    })
  }
  showFFilter() {
    this.filterChange.emit(this.filter);
  }
  subfilterStateChanged(filter: Filter, value: ServerFilterValue) {
    if (this.blocked) {
      return
    }
    value.active = !value.active;
   // console.log('filter', filter,'value', value);
    if (value.active) {
      if (filter.name) {
        this.addFilterValue(filter.name, value);
        if (this.assetFilter) {
          this.assetStateService.filter = this.assetFilter;
        }
      }
    } else {
      if (filter.name) {
        this.removeFilterValue(filter.name, value);
        if (this.assetFilter) {
          this.assetStateService.filter = this.assetFilter;
        }
      }
    }
  }
  removeFilterValue(filterName: string, value: ServerFilterValue) {
    // if filter to remove = divisiona, also remove sports filters
    // if filter to remove = productCategory also remove product Type filters
   // console.log('filtername', filterName, value)
    if (this.assetFilter) {
      const key: string = 'p_' + filterName;
      if (this.assetFilter[key]) {
        const arr = this.assetFilter[key] as Array<string>;
        let index = arr.indexOf(value.value);
        if (index !== -1) {
          arr.splice(index, 1);
        }
        this.assetFilter.page = 1;
      }
      if (filterName === 'division') {
        if (this.assetFilter['p_sport']) {
          this.assetFilter['p_sport'] = [];
        }
      }
      if (filterName === 'product_category') {
        if (this.assetFilter['p_product_type']) {
          this.assetFilter['p_product_type'] = [];
        }
      }
    }
  }
  checkIfStillSelected() {
   // console.log('checking filter?', this.filter);
    if (this.assetFilter) {
      if (this.filter && this.filter.filters) {
        for (const f of this.filter.filters) {
          const key: string = 'p_' + f.name;
         // console.log('checking', key);
          // console.log('filter', this.filter)
          if (this.assetFilter[key]) {
            const arr = this.assetFilter[key] as Array<string>;
             if (f.values) {
               for (const val of f.values) {
                 val.active = false;
                 for (const entry of arr) {
                  if (val.value === entry) {
                      val.active = true;
                  }
               }
             }
           }
          }
        }
      }
    }
  }
  addFilterValue(filterName: string, value: ServerFilterValue) {
   // console.log('filterGroupname', filterName);
    if (this.assetFilter) {
      const key: string = 'p_' + filterName;
      if (!this.assetFilter[key]) {
        this.assetFilter[key] = [];
        this.assetFilter[key].push(value.value);
        this.assetFilter.page = 1;
      } else {
        const arr = this.assetFilter[key] as Array<string>;
        arr.push(value.value);
        this.assetFilter.page = 1;
      }
    }
  }
  ngOnDestroy() {
    if (this.assetFilterSubscription) {
      this.assetFilterSubscription.unsubscribe();
    }
    if (this.blockedSubscription) {
      this.blockedSubscription.unsubscribe();
    }
  }

}
